import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useAction } from '../../hooks/store-hooks';
import { Login } from '../../stores/login';

const LogoutButton: React.ComponentType = () => {
  const saveLogin = useAction(Login.actions.set);

  const logout = () => {
    saveLogin(undefined);
  };

  return (
    <button className="exit-button" onClick={() => logout()}>
      <FontAwesomeIcon icon={faArrowRightFromBracket} />
    </button>
  );
};

export default LogoutButton;
